<section class="custom-modal" role="dialog" aria-modal="true" aria-labelledby="password-reset-link-title">
  <header class="modal-header">
    <div class="modal-header-text">
      <h2 id="password-reset-link-title" class="modal-title">User created</h2>
      <p class="modal-subtitle">The colleague must set their password before they can sign in.</p>
    </div>
  </header>

  <div class="modal-body">
    <div class="status-card" [class.status-card-success]="emailSent" [class.status-card-warning]="!emailSent">
      <app-display-icon
        [border]="false"
        [colour]="emailSent ? iconColourEnum.green : iconColourEnum.yellow"
        [icon]="emailSent ? icons.checkCircle : icons.infoSlabCircleOutline">
      </app-display-icon>

      <div class="status-copy">
        <h3>{{ emailSent ? 'Password reset email sent' : 'Password reset email could not be sent' }}</h3>
        <p>
          @if (emailSent) {
            A password reset email was sent to {{ email }}.
          } @else {
            Copy the password reset link and share it securely with {{ email }}.
          }
        </p>
      </div>
    </div>

    <p class="access-note">This colleague has no store access yet. Assign their access from their user profile.</p>

    @if (hasCopied()) {
      <p class="copy-status">Password reset link copied to your clipboard.</p>
    } @else if (copyFailed()) {
      <p class="copy-status copy-status-error">The browser could not copy the link. Please try again.</p>
    }
  </div>

  <footer class="modal-footer">
    <app-shared-button
      [colour]="'primary'"
      [disabled]="isCopying()"
      (click)="onCopyPasswordResetLinkClick()">
      <app-display-icon
        class="copy-button-icon"
        [border]="false"
        [colour]="iconColourEnum.primary"
        [icon]="hasCopied() ? icons.clipboardCheckOutline : icons.contentCopy">
      </app-display-icon>
      {{ hasCopied() ? 'Copy again' : 'Copy password reset link' }}
    </app-shared-button>

    <app-shared-button
      [colour]="'primary'"
      [fill]="true"
      (click)="onContinue()">
      Continue
    </app-shared-button>
  </footer>
</section>
